import script from "./HiddenTokensPills.vue?vue&type=script&setup=true&lang=ts"
export * from "./HiddenTokensPills.vue?vue&type=script&setup=true&lang=ts"

import "./HiddenTokensPills.vue?vue&type=style&index=0&id=3c37109a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c37109a"]])

export default __exports__